import './style.scss';
import Label from './label.js';

export default Label;